export default __webpack_public_path__ + "static/anggrek-fb19a5cdc9dcd15dc2eaee3e4b2ad81e.png";